import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.BankAccountCard.RenameBankAccountForm', {
    save: 'Save',
    bankAccountNickname: 'Bank account nickname',
});
